import { CognitoIdToken } from "amazon-cognito-identity-js";
export const addUserInfoFromToken = (idToken?: CognitoIdToken) => {
  if (!idToken) return {};
  const payload = idToken.decodePayload();
  const { family_name, given_name, email, phone_number } = payload;
  const username = payload["cognito:username"];
  const domusoId = payload["custom:domusoId"];
  const preferred_username = payload["cognito:preferred_username"] || payload["cognito:username"];
  return { username, domusoId, preferred_username, email, family_name, given_name, phone_number };
};
